export default "__VITE_ASSET__CO$43ls1__"